<template>
	<figure :class="['shadowed-image' ,'position-'+position]">
		<img :src="src" class="image" v-if="type=='img'">
		<BackgroundVideo :src="src" class="image" v-if="type=='video'" />
		<img :src="shadow" class="shadow" >
	</figure>
</template>

<script>

	import BackgroundVideo from '@/components/VideoServerBackgroundVideo'

	export default {
		name: "shadowedImage",
		components: { BackgroundVideo },
		props: {
			src: String,
			type: {
				type: String,
				default: "img"
			},
			shadow: String,
			position: {
				type: String,
				default: "bottom"
			}
		}
	}

</script>

<style lang="scss" scoped>
	@import "media.scss";

	.shadowed-image {
		position:relative;
		@include media(large) {
			margin-right:5rem;
		}
	}
	.image {
		display:block;
	}
	.shadow {
		position:absolute; top:100%; left:0; right:0; max-width:none;
	}
	.position-right-bottom {
		margin-bottom:-30rem;
		.shadow {
			top:0; left:auto; transform:translateX(50%); z-index:-1;
		}
	}
	.position-bottom-center {
		.image,.shadow {
			width:100%;
		}
		.shadow {
			top:100%; z-index:2;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/ShadowedImage.vue